<header class="d-none d-sm-none d-md-none d-lg-block">
  <div class="logo">
    <i class="icon-logo" style="--size: 40px"></i>
  </div>

  <div class="setting">
    <button [matMenuTriggerFor]="menu">
      <i class="icon-setting" style="--size: 22px"></i> Settings
      <i class="icon-caret" style="--size: 5px"></i>
    </button>
    <mat-menu #menu="matMenu" style="margin-top: 5px" class="active">
      <button Shape-1-copy mat-menu-item center routerLink="/ApiGroup">
        API Manager
      </button>

      <button mat-menu-item center (click)="logout($event)">Logout</button>
    </mat-menu>
  </div>

  <!-- <div class="user-profile">
    <img src="assets/profile.jpg" />
    {{ userName.unique_name }}
  </div> -->

  <div class="color-switcher">
    <i class="colorswitcher-active" style="--size: 35px"></i>
    <div *ngIf="!darkTheme.value" class="lighttext">Light Mode</div>
    <label class="switch">
      <input id="darkTheme.value" type="checkbox" [formControl]="darkTheme" />
      <span class="slider round"></span>
    </label>
    <div *ngIf="darkTheme.value" class="text">Dark Mode</div>
  </div>
  <div class="topmenu">
    <ul>
      <li routerLinkActive="active">
        <a href="#" routerLink="/apiManager"
          ><img src="assets/img/icons/search.svg" />Api</a
        >
      </li>

      <!--    <li routerLinkActive="active">
        <a href="#" routerLink="/entity"
          ><img src="assets/img/icons/raspoitory.svg" />Entity</a
        >
      </li>  -->

      <li routerLinkActive="active">
        <a href="#" routerLink="/attributeList"
          ><img src="assets/img/icons/cases.svg" />Attribute</a
        >
      </li>

      <li routerLinkActive="active">
        <a href="#" routerLink="/category"
          ><img src="assets/img/icons/compare.svg" />Category</a
        >
      </li>

      <li routerLinkActive="active">
        <a href="#" routerLink="/subcategory"
          ><img src="assets/img/icons/compare.svg" />SubCategory</a
        >
      </li>

      <!--    <li routerLinkActive="active">
       <a href="#" routerLink="/category">
      <img src="assets/img/icons/user.svg" />Category
      </a>
      </li>  -->

      <!--  <li routerLinkActive="active">
      <a href="#" routerLink="/subcategory">
      <img src="assets/img/icons/compare.svg" /> SCategory
      </a>
      </li>  -->
      <li routerLinkActive="active">
        <a href="#" routerLink="/user">
          <img src="assets/img/icons/compare.svg" />User Management
        </a>
      </li>

      <li routerLinkActive="active">
        <a href="#" routerLink="/repository">
          <img src="assets/img/icons/compare.svg" />Repository
        </a>
      </li>

      <!-- <li routerLinkActive="active">
        <a href="#" routerLink="/analytics">
       <img src="assets/img/icons/compare.svg" />Analytics</a></li> -->

      <!-- <li [ngClass]= "{'active': (route.url.includes('/ApiGroupForm') ||   route.url.includes('/ApiGroup') ||
           route.url.includes('/apiManager') || route.url.includes('/responseMapping') ||  route.url.includes('/responseMappingForm'))}">
        <a href="#" routerLink="/ApiGroup">
       <img src="assets/img/icons/compare.svg" />Api Group</a></li>
     -->
      <li>
        <a href="#" routerLink="/ApiGroup">
          <img src="assets/img/icons/compare.svg" />Api Group</a
        >
      </li>
    </ul>
  </div>
</header>

<!-- mobile header -->
<!-- <header class="d-block d-md-block d-lg-none mobileheader">
  <div class="logo"><img src="assets/img/ocular.png" /></div>

  <div class="setting">
    <button [matMenuTriggerFor]="menu">
      <i class="icon-setting" style="--size:22px"></i>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openModal($event)">
        Add Custom Source
      </button>
      <button mat-menu-item (click)="logout($event)">Logout</button>
    </mat-menu>
  </div>
  <div class="addbtn">
    <button (click)="openModal($event)">
      <img src="assets/img/icons/add.svg" />
    </button>
  </div>
  <div class="menubtn">
    <button [matMenuTriggerFor]="mobmenu">
      <img src="assets/img/icons/menu.png" />
    </button>
    <mat-menu #mobmenu="matMenu">
      <button mat-menu-item routerLink="/dashboard">Search</button>
      <button mat-menu-item routerLink="/cases">Cases</button>
      <button mat-menu-item routerLink="/repository">Repository</button>
      <button mat-menu-item>Profiling</button>
    </mat-menu>
  </div>
</header> -->
